import axios from 'axios';

export const setupAxiosInterceptors = (logout) => {
    // Remove any existing interceptors to avoid duplicates
    axios.interceptors.response.eject(axios.interceptors.response.handlers.length - 1);

    // Add response interceptor
    axios.interceptors.response.use(
        (response) => {
            // Return successful responses as-is
            return response;
        },
        (error) => {
            // Handle errors
            if (error.response?.status === 403 &&
                error.response?.data?.message === "Invalid Token") {
                console.log("Token expired, logging out user");
                logout();
                // Don't redirect here, let the routing handle it
            }
            return Promise.reject(error);
        }
    );
};